<!--教室管理-->
<template>
    <div  v-loading="loading">
        <!--<div class="card-header">-->
        <!--<h5>教室管理</h5>-->
        <!--</div>-->
        <div class="left m-portlet">
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-popover placement="right" v-model="visible2">
                            <el-form :label-position="labelPosition">
                                <el-form-item label="教室地点:">
                                    <el-input v-model="classroom.name" placeholder="请输入教室地点"></el-input>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="handleClassroomAddress(classroom.name)"
                                               :loading="button_loading">确认添加
                                    </el-button>
                                </el-form-item>
                            </el-form>
                            <el-button slot="reference" v-if="powers.includes(15)">新增教室地点</el-button>
                        </el-popover>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" size="small" @click="handleStoreClassroom()" :loading="button_loading"
                                   v-if="powers.includes(15)">
                            保存修改教室
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right">
                <el-tabs type="border-card">
                    <el-tab-pane v-model="activeName"
                                 v-for="(item, index) in collapseItem" :label="index" :key="index">
                        <vue-scroll :ops="$ops" :style="{'height':(clientHeight-255)+'px'}">
                            <div class="m-portlet__body">
                                <el-form :label-position="labelPosition"
                                         v-for="(classroom, index1) in item"
                                         :model="classroom">
                                    <el-row :gutter="20">
                                        <el-col v-if="clientWeight/2>850" :span="11">
                                            <el-row :gutter="20">
                                                <el-col :span="8">
                                                    <el-form-item label="房间号:">
                                                        <el-input v-model="classroom.classroom_num" placeholder="请输入房间号"
                                                                  style="width: 100px"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-form-item label="人数:">
                                                        <el-input v-model="classroom.student_num"
                                                                  placeholder="请输入人数"
                                                                  style="width: 100px"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="8" align="center">
                                                    <el-row :gutter="20">
                                                        <el-col :span="10">
                                                            <el-button v-if="powers.includes(14)"
                                                                       @click="handleDelClassroomNum(index,index1)"
                                                                       :loading="button_loading">删除
                                                            </el-button>
                                                        </el-col>
                                                        <!--                                                        <el-col :span="10" v-if="powers.includes(15)">-->
                                                        <!--                                                            <el-button v-if="classroom.write == true"-->
                                                        <!--                                                                       @click="handleUpdateClassroomNum(classroom)"-->
                                                        <!--                                                                       :loading="button_loading">修改-->
                                                        <!--                                                            </el-button>-->
                                                        <!--                                                            <el-button v-else-->
                                                        <!--                                                                       @click="handleUpdateClassroomNum(classroom)"-->
                                                        <!--                                                                       :loading="button_loading">保存-->
                                                        <!--                                                            </el-button>-->
                                                        <!--                                                        </el-col>-->
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                        <el-col v-else :span="24">
                                            <el-row :gutter="20">
                                                <el-col :span="8">
                                                    <el-form-item label="房间号:">
                                                        <el-input v-model="classroom.classroom_num" placeholder="请输入房间号"
                                                                  style="width: 100px"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-form-item label="人数:">
                                                        <el-input v-model="classroom.student_num"
                                                                  placeholder="请输入人数"
                                                                  style="width: 100px"></el-input>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="8" align="center">
                                                    <el-row :gutter="20">
                                                        <el-col :span="10">
                                                            <el-button v-if="powers.includes(14)"
                                                                       @click="handleDelClassroomNum(index,index1)"
                                                                       :loading="button_loading">删除
                                                            </el-button>
                                                        </el-col>
                                                        <!--                                                        <el-col :span="10" v-if="powers.includes(15)">-->
                                                        <!--                                                            <el-button v-if="classroom.write == true"-->
                                                        <!--                                                                       @click="handleUpdateClassroomNum(classroom)"-->
                                                        <!--                                                                       :loading="button_loading">修改-->
                                                        <!--                                                            </el-button>-->
                                                        <!--                                                            <el-button v-else-->
                                                        <!--                                                                       @click="handleUpdateClassroomNum(classroom)"-->
                                                        <!--                                                                       :loading="button_loading">保存-->
                                                        <!--                                                            </el-button>-->
                                                        <!--                                                        </el-col>-->
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-col>
                                    </el-row>
                                </el-form>
                                <el-row :gutter="20">
                                    <el-col :span="3" v-if="powers.includes(13)">
                                        <el-button
                                                @click="handleAddClassroomNum(index)"
                                                :loading="button_loading">新增房间号
                                        </el-button>
                                    </el-col>
                                    <el-col :span="6" v-if="powers.includes(14)">
                                        <el-button
                                                @click="handleDeleteClassroom(0,index)"
                                                :loading="button_loading">删除所有教室
                                        </el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </vue-scroll>

                    </el-tab-pane>
                </el-tabs>
        </div>
    </div>
</template>


<style>
    .left {
        width: 170px;
        float: left;
    }

    .right {
        margin-left: 180px;
    }

</style>

<script>
    export default {
        data() {
            return {
                path: '/classrooms',
                loading: true,
                button_loading: false,
                classroom: {
                    name: ''
                },
                classrooms: [],
                activeName: '1',
                labelPosition: 'left',
                resultView: '',
                collapseItem: [],
                visible2: false,
            }
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            clientWeight() {
                return this.$store.state.config.clientWidth;
            },
        },
        created() {
            this.handleIndexClassroom();
            this.handleCreate();
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'get_classrooms':
                        if (Object.keys(data.classrooms).length > 0) {
                            this.collapseItem = data.classrooms;
                        } else {
                            this.collapseItem = new Object()
                        }
                        this.loading = false;
                        break;
                    case 'store_classroom':
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.button_loading = false;
                        break;
                    case 'store_classroom_error':
                        this.button_loading = false;
                        break;
                    case 'delete_classroom':
                        this.$message({
                            message: '移除成功',
                            type: 'success'
                        });
                        if (Object.keys(data.classrooms).length > 0) {
                            this.collapseItem = data.classrooms;
                        } else {
                            this.collapseItem = new Object()
                        }
                        this.button_loading = false;
                        break;
                    case 'delete_classroom_error':
                        this.button_loading = false;
                        break;
                    case 'update_classroom':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        if (Object.keys(data.classrooms).length > 0) {
                            this.collapseItem = data.classrooms;
                        } else {
                            this.collapseItem = new Object()
                        }
                        this.button_loading = false;
                        break;
                    case 'update_classroom_error':
                        this.button_loading = false;
                        break;
                }
            },
            //获取教室信息
            handleIndexClassroom() {
                this.$wApi.send(this.path, 'get_classrooms');
            },
            //保存教室信息
            handleStoreClassroom() {
                this.button_loading = true;
                this.$wApi.send(this.path, 'store_classrooms', {
                    'classrooms': this.collapseItem,
                });
            },
            //移除教室 true
            handleDeleteClassroom(id, name) {
                this.button_loading = true;
                this.$wApi.send(this.path, 'delete_classroom', {
                    'id': id,
                    'name': name,
                });
            },
            //增加新的教室地点
            handleClassroomAddress(name) {
                if (name === '') {
                    this.$message({
                        message: '教室地点名不能为空',
                        type: 'warning'
                    });
                } else {
                    let vm = this;
                    for (const key in this.collapseItem) {
                        if (key === name) {
                            this.$message.error('该教室地点已存在');
                        }
                    }
                    let new_classroom = [{
                        id: '',
                        classroom_num: '',
                        student_num: '',
                        name: name,
                        write: false,
                    }];
                    this.$set(this.collapseItem, name, new_classroom);
                }
                this.visible2 = false;
            },
            //删除房间号
            handleDelClassroomNum(index, index1) {
                this.button_loading = true;
                if (!this.collapseItem[index][index1].write) {
                    this.collapseItem[index].splice(index1, 1);
                    this.button_loading = false;
                } else {
                    this.handleDeleteClassroom(this.collapseItem[index][index1].id, '');
                }
            },
            handleUpdateClassroomNum(classroom) {
                this.button_loading = true;
                this.$wApi.send(this.path, 'update_classroom', {
                    'id': classroom.id,
                    'classroom_num': classroom.classroom_num,
                    'student_num': classroom.student_num,
                    'name': classroom.name,
                    'write': classroom.write,
                });
            },
            //新增房间号
            handleAddClassroomNum(index) {
                this.collapseItem[index].push({
                    id: 0,
                    name: index,
                    classroom_num: '',
                    student_num: '',
                    write: false,
                });
            },
        }
    }
</script>
